module.exports = __webpack_public_path__ + "img/postAddIcon.1e790d91.svg";